/**
 * @fileoverview Renders import missions button
 */

import React from 'react'
import injectStyles from 'react-jss'
import { Button } from '../../../../../Components/Buttons/Button'

const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    '& + *': {
      marginLeft: '16px',
    },
  },
}

/**
 * Returns import missions button with on click actionn received from props
 *
 * @param {Function} props.onClick Will be called on click
 * @param {Boolean} props.hidden Indicates whether button should be displayed
 *
 * @returns JSX.Element
 *
 * @example <ImportButton onClick={() => {}} />
 */
const ImportButton = ({ onClick, hidden, classes }) => {
  if (hidden) return null
  return (
    <div className={classes.wrapper}>
      <Button onClick={onClick} cypress_id="roster-import-missions-button">
        Import missions
      </Button>
    </div>
  )
}

export default injectStyles(styles)(ImportButton)
